import React from 'react';
import { Form, Icon, Input, Button, Layout, Col, Row } from 'antd';

import ApiService from './../../../utils/ApiService';
import { setAuthToken } from './../../../utils/Helper';

import i18n from './../../../utils/i18n';

const { Content } = Layout;
const FormItem = Form.Item;

class Login extends React.Component {
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        // console.log('Received values of form: ', values);
        ApiService.user_accounts()
          .login(values)
          .then(resp => {
            if (resp.status === 200) {
              setAuthToken(resp.data.token);
              window.location = window.location;
            }
          });
        return true;
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Content className="content">
        <div className="default-layout">
          <Row type="flex" justify="center" style={{ marginTop: '5%' }}>
            <Col span={4}>
              <Form onSubmit={this.handleSubmit} className="login-form">
                <FormItem>
                  {getFieldDecorator('email', {
                    rules: [
                      {
                        required: true,
                        message: 'Bitte geben Sie eine E-Mail ein.'
                      }
                    ]
                  })(
                    <Input
                      prefix={
                        <Icon
                          type="user"
                          style={{ color: 'rgba(0,0,0,.25)' }}
                        />
                      }
                      type="email"
                      name="ff_email"
                      placeholder="E-Mail"
                    />
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator('password', {
                    rules: [
                      {
                        required: true,
                        message: 'Bitte geben Sie ein Passwort ein.'
                      }
                    ]
                  })(
                    <Input
                      prefix={
                        <Icon
                          type="lock"
                          style={{ color: 'rgba(0,0,0,.25)' }}
                        />
                      }
                      type="password"
                      placeholder="Passwort"
                    />
                  )}
                </FormItem>
                <FormItem>
                  <Button
                    aria-label={i18n.actions.signIn}
                    type="primary"
                    htmlType="submit"
                    className="login-form-button"
                  >
                    {i18n.actions.signIn}
                  </Button>
                </FormItem>
              </Form>
            </Col>
          </Row>
        </div>
      </Content>
    );
  }
}

const WrappedLogin = Form.create()(Login);
export default WrappedLogin;



// WEBPACK FOOTER //
// ./src/containers/Auth/Login/index.js